document.documentElement.classList.add('js');
(function(){
  var hdr=document.getElementById('hdr');
  function onScroll(){
    if(!hdr) return;
    var hero=document.querySelector('.hero');
    var t=hero?Math.min(hero.offsetHeight-90,420):10;
    hdr.classList.toggle('solid', window.scrollY>t);
  }
  addEventListener('scroll',onScroll,{passive:true}); onScroll();

  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px -8% 0px',threshold:.05});
  document.querySelectorAll('[data-rev]').forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.top<innerHeight*0.95){ el.classList.add('in'); } else { io.observe(el); }
  });

  document.querySelectorAll('[data-count]').forEach(function(el){
    var co=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return; co.disconnect();
        var end=parseInt(el.dataset.count,10), suf=el.dataset.suf||'', t0=null;
        function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/1100,1);
          el.textContent=Math.round(end*(1-Math.pow(1-p,3)))+suf; if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    },{threshold:.4});
    co.observe(el);
  });
})();
